<template>
    <div class="auth-content" style="height: 100%">
        <div class="row m-0 h-100">
            <!-- left section image -->
            <div class="col-md-6 d-md-flex d-none p-3 bg-authentication minh-100" style="flex: 1">
                <div class="d-flex justify-content-center align-items-center auth-text pt-4">
                    <div class="row text-center">
                        <inline-svg class="mb-5" src="/assets/img/logo/logo_magnus_teams.svg"></inline-svg>
                        <h4 class="auth-title">Magnus Support Team Dashboard</h4>
                        <p class="auth-subtitle --faded">With MagnusTeams you will be able to support Heroes who are using the MagnusCards app to be more independent by creating and scheduling daily activities.</p>
                    </div>
                </div>
                <div class="row d-flex justify-content-center align-items-center" style="flex: 1">
                    <img draggable="false" alt="branding logo" class="img-fluid"
                         style="height: 180px; padding-right: 120px"
                         src="/assets/img/logo/logo_big_hand_peace.svg">
                </div>
            </div>
            <!-- right section-login -->
            <div class="col-md-6 col-12 minh-100 px-0">
                <div class="p-2 minh-100 d-flex">
                  <div class="auth-form" v-if="form === 'login'">
                    <div>
                      <div class="auth-form --title">Welcome to MagnusTeams!</div>
                      <div class="auth-gray-text text-center mb-4" style="font-size: 16px">
                        If you already have an account with <strong>MagnusCards</strong>, simply log in below to get started. </br>
                        New to MagnusTeams? No worries! You can create a new account by clicking the link below.
                      </div>
                      <form-input class="mb-2" inputClass="form-control-lg" type="email" label="Email"
                                  placeholder="Enter your email" v-model="login.email" :v="$v.login.email"
                                  v-on:keyup.enter="signIn()"/>
                      <form-input-password inputClass="form-control-lg" class="mb-2" label="Password"
                                           placeholder="Enter password" v-model="login.password"
                                           :v="$v.login.password" v-on:keyup.enter="signIn()"/>

                      <div class="row">
                        <div class="col text-left">
                          <form-checkbox text="Remember me"></form-checkbox>
                        </div>
                        <div class="col text-right mb-2">
                          <a @click.prevent="form = 'reset'" class="card-link link-primary" href="#">
                            Forgot password
                          </a>
                        </div>
                      </div>
                      <div>
                        <btn class="btn-primary btn-lg w-100 mb-2"
                             :loading="loading.login"
                             :disabled="!login.email || !login.password"
                             v-on:click="signIn()">
                          Log in
                        </btn>
                        <btn class="btn-google btn-lg w-100 mb-2"
                             :loading="loading.login"
                             @click="AuthProvider('google')">
                          <inline-svg src="/assets/img/google_icon.svg"/>
                          Log in with Google
                        </btn>
                        <btn class="btn-facebook btn-lg w-100 mb-3"
                             :loading="loading.login"
                             @click="AuthProvider('facebook')">
                          <inline-svg src="/assets/img/facebook_icon.svg"/>
                          Log in with Facebook
                        </btn>
                      </div>
                      <div class="col text-center auth-gray-text auth-gray-card">
                        <div class="auth-gray-card-icon">
                          <inline-svg stroke="#7F56D9" src="/assets/img/icons/user-plus01.svg"></inline-svg>
                        </div>
                        <div class="auth-gray-card-title">Are you new here?</div>
                        <div>You can always create a new account</div>
                        <div class="p-1">
                          <a @click.prevent="switchToRegister()" class="card-link link-primary" href="#">
                            Create an account
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="auth-form" v-if="form === 'register' && registerStep === 1">
                    <div class="auth-form --title">Create your account</div>
                    <div class="auth-gray-text text-center mb-4" style="font-size: 16px">
                      If you already have an account,<br> sign in down below
                    </div>
                    <form-input inputClass="form-control-lg" class="mb-2" :label="'Name*'"
                                placeholder="Enter your name" v-model="register.name" :v="$v.register.name"/>
                    <form-input inputClass="form-control-lg" type="email" class="mb-2" :label="'Email*'"
                                placeholder="Enter your email" v-model="register.email" :v="$v.register.email"/>
                    <form-input-password inputClass="form-control-lg" type="password" :label="'Password*'"
                                         placeholder="Create a password" v-model="register.password"
                                         :v="$v.register.password"/>
                    <div class="auth-gray-text mb-2">*Password must be at least 8 characters, one uppercase
                      letter, at least one number and one symbol.
                    </div>
                    <form-input-password inputClass="form-control-lg"
                                         :class="{'mb-2' : !$v.register.confirm_password.$error}"
                                         type="password" :label="'Confirm password*'" placeholder=""
                                         v-model="register.confirm_password" :v="$v.register.confirm_password"/>
                    <div v-if="$v.register.confirm_password && $v.register.confirm_password.$error"
                         class="text-danger mb-2" style="font-size: 14px;">*Password and confirm password does
                      not match
                    </div>
                    <form-checkbox class="mb-2" v-model="register.terms" :v="$v.register.terms">
                      I agree with the <a style="color: black" href="https://magnusmode.com/terms-and-conditions/" target="_blank">terms and conditions</a>
                    </form-checkbox>
                    <div v-if="$v.register.terms && $v.register.terms.$error"
                         class="text-danger mb-2" style="font-size: 14px;">*You need to accept terms and conditions
                    </div>

                    <div class="text-center">
                      <btn class="btn-primary btn-lg w-100 mb-2"
                           :loading="loading.register"
                           :disabled="!register.name || !register.email || !register.password || !register.confirm_password"
                           v-on:click="registerNextStep()">Get started
                      </btn>
                      <btn class="btn-google btn-lg w-100 mb-2"
                           :loading="loading.login"
                           @click="AuthProvider('google')">
                        <inline-svg src="/assets/img/google_icon.svg"/>
                        Sign in with Google
                      </btn>
                      <btn class="btn-facebook btn-lg w-100 mb-3"
                           :loading="loading.login"
                           @click="AuthProvider('facebook')">
                        <inline-svg src="/assets/img/facebook_icon.svg"/>
                        Sign in with Facebook
                      </btn>
                    </div>
                    <div class="col text-center auth-gray-text" v-if="form === 'register'">
                      <div class="mb-1">Already have an account?</div>
                      <div>
                        <a @click.prevent="switchToLogin()" class="card-link link-primary" href="#">
                          Log in
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="auth-register-steps-container" v-if="form === 'register' && registerStep === 2">
                    <div>
                      <div class="auth-gray-text text-center" style="font-size: 16px; margin-bottom: 12px">
                        We would like to know more about you
                      </div>
                      <div class="auth-form --title">What type of user are you?</div>
                      <div class="auth-type-container">
                        <input type="radio" class="btn-check" name="options-outlined" id="caregiver-outlined" autocomplete="off" checked
                               value="caregiver" v-model="register.user_type">
                        <label class="auth-type-card" for="caregiver-outlined">
                          <inline-svg src="assets/img/icons/face-happy.svg"></inline-svg>
                          Caregiver
                        </label>

                        <input type="radio" class="btn-check" name="options-outlined" id="professional-outlined" autocomplete="off"
                               value="professional" v-model="register.user_type">
                        <label class="auth-type-card" for="professional-outlined">
                          <inline-svg src="assets/img/icons/face-happy.svg"></inline-svg>
                          Professional
                        </label>
                      </div>
                      <div class="auth-form --title" style="font-size: 20px; margin-top: 64px">
                        <span>What type of <span class="text-capitalize">{{register.user_type}}</span> are you?</span>
                      </div>
                      <div class="row">
                        <div v-for="userProfession in userProfessionData[register.user_type]" class="col-6 mx-auto">
                          <div v-if="userProfession !== 'Other' || (userProfession === 'Other' && !other_selected)" class="auth-type-card --subtype"
                               :class="{'--selected': register.user_profession === userProfession}"
                               @click="selectUserTypeDetail(userProfession)"
                          >
                            {{userProfession}}
                          </div>
                          <form-input v-if="userProfession === 'Other' && other_selected"
                                      inputClass="form-control-lg"
                                      :label="'Other'"
                                      placeholder="Please specify" v-model="register.user_profession"
                                      style="margin-top: 12px"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="text-center w-100">
<!--                      <div class="auth-register-steps-footer d-flex flex-1">-->
<!--                        <div class="auth-register-steps-logo">-->
<!--                          <inline-svg src="/assets/img/logo/logo_small.svg"/>-->
<!--                        </div>-->
<!--                        <div class="auth-register-steps-text">-->
<!--                          <div>Are you a caregiver or professional?</div>-->
<!--                          <div class="auth-register-steps-text &#45;&#45;grayed">-->
<!--                            Learn more about <span class="auth-register-steps-text &#45;&#45;primary">MagnusTeams</span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <btn class="btn-primary btn-lg"
                           :loading="loading.register"
                           :disabled="!register.name || !register.email || !register.password || !register.confirm_password"
                           v-on:click="signUp()">Get started
                      </btn>
                    </div>
                  </div>
                  <div class="auth-form" v-if="form === 'reset'">
                    <div>
                      <div class="d-flex justify-content-center">
                        <div class="auth-icon mb-3">
                          <inline-svg src="/assets/img/icons/key-01.svg"/>
                        </div>
                      </div>
                      <div class="auth-form --title mb-1">Forgot your <br> MagnusTeams Password?</div>
                      <div class="auth-gray-text text-center mb-4" style="font-size: 16px">
                        Don’t worry, I’m on it! <br><br>
                        Just let me know your email address, and I'll send over recovery instructions.
                      </div>
                      <form-input inputClass="form-control-lg" class="mb-2" type="email" label="Email"
                                  placeholder="Enter your email" v-model="reset.email" :v="$v.reset.email"/>
                      <div class="text-center mb-3">
                        <btn :loading="loading.reset"
                             class="btn-primary btn-lg w-100"
                             :disabled="!reset.email"
                             v-on:click="resetPasswordEmail">
                          Reset password<i class="bx bx-right-arrow-alt" id="icon-arrow"></i>
                        </btn>
                      </div>

                      <div class="text-center d-flex justify-content-center align-items-center">
                        <a class="link-primary auth-gray-text auth-back"
                           @click.prevent="form = 'login'"
                           href="#">
                          <inline-svg class="me-1"
                                      height="12px"
                                      style="margin-bottom: 3px"
                                      src="/assets/img/back_icon.svg"/>
                          Back to log in
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="auth-form" v-if="form === 'recover'">
                    <div>
                      <div class="d-flex justify-content-center">
                        <div class="auth-icon mb-3">
                          <inline-svg src="/assets/img/icons/key-01.svg"/>
                        </div>
                      </div>
                      <div class="auth-form --title mb-1">Reset your <br> MagnusTeams Password?</div>
                      <div class="auth-gray-text text-center mb-4" style="font-size: 16px">
                        Enter a new password and confirmation to reset the password
                      </div>
                      <form-input-password inputClass="form-control-lg" class="mb-2" type="password"
                                           label="New password*" placeholder="Enter new password"
                                           v-model="recover.password" :v="$v.recover.password"/>
                      <form-input-password inputClass="form-control-lg" class="mb-2" type="password"
                                           label="Confirm new password*" placeholder="Confirm new password"
                                           v-model="recover.confirm_password" :v="$v.recover.confirm_password"/>

                      <div class="text-center">
                        <btn :loading="loading.recover"
                             :class="{'loading-btn': loading.recover}"
                             class="btn-primary btn-lg mb-2 w-100"
                             v-on:click="recoverPassword()">
                          Reset password<i class="bx bx-right-arrow-alt" id="icon-arrow"></i>
                        </btn>
                      </div>

                      <div class="text-center mb-2">
                        <btn class="btn-outline-light btn-lg w-100" @click="switchToLogin">
                          Cancel request
                        </btn>
                      </div>
                    </div>
                  </div>
                  <div class="auth-form" v-if="form === 'email_sent'">
                    <div class="text-center">
                      <inline-svg class="mb-3" src="/assets/img/check_icon.svg"/>
                      <div class="auth-form --title mb-1">Email has been sent</div>
                      <div class="auth-gray-text text-center mb-4" style="font-size: 16px; line-height: 24px">
                        Please follow the instructions I've prepared to reset your password.
                      </div>
                      <div class="text-center mb-4 auth-gray-text">
                        <div class="mb-1">If you don't see the email in your inbox,</div>
                        <div>
                          <a @click.prevent="form = 'reset'" class="link-primary" href="#">
                            Click here to resend
                          </a>
                        </div>
                      </div>
                      <div class="text-center d-flex justify-content-center align-items-center">
                        <a class="link-primary auth-gray-text auth-back" @click.prevent="switchToLogin" href="#">
                          <inline-svg class="me-1" height="12px" style="margin-bottom: 3px"
                                      src="/assets/img/back_icon.svg"/>
                          Back to log in
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <modal name="wrongAccountTypeModal" height="auto" width="400px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <div class="w-100 text-center" style="position: relative">
                        <inline-svg class="mb-2" src="/assets/img/icons/alert-triangle-circle.svg"></inline-svg>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('wrongAccountTypeModal')"></button>
                    </div>
                    <h4 class="modal-title">Oopsie!</h4>
                    <div class="modal-subtitle-gray text-center ps-2 pe-2">
                        Seems like this email address is being used in MagnusCards for a Hero account.
                    </div>
                </div>
                <div class="modal-body d-flex flex-column align-items-center pt-3 pb-4">
                    <div class="modal-subtitle-gray text-center">
                        To create a <b>Caregiver account</b>, use an email address that is not in use in MagnusCards.
                    </div>
                </div>
                <div class="d-flex flex-column gap-2 p-3" >
                    <div class="d-flex flex-row justify-content-between gap-2">
                        <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('removeHeroModal')">Close</btn>
                        <btn class="btn-primary btn-lg flex-1"
                             @click="switchToRegister">
                            Create account
                        </btn>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import FormInput from "/src/components/core/FormInput";
import FormInputPassword from "/src/components/core/FormInputPassword";
import FormCheckbox from "../components/core/FormCheckbox.vue";
import Btn from '/src/components/core/Btn'
import BtnIcon from "@/components/core/BtnIcon.vue";

const {required, sameAs, minLength, email} = require('vuelidate/lib/validators');
import {passwordValidators} from '@/validators';
import {mapState} from 'vuex';
import PasswordValidation from "@/components/core/PasswordValidation.vue";
import {minValue} from "vuelidate/lib/validators";
import UserAvatar from "@/components/UserAvatar.vue";

export default {
    name: 'Auth',
    components: {UserAvatar, PasswordValidation, BtnIcon, FormInput, FormInputPassword, FormCheckbox, Btn},
    data() {
        return {
            form: 'login',
            message: '',
            error: null,
            other_selected: false,
            loading: {
                login: false,
                reset: false,
                recover: false
            },
            login: {
                email: '',
                password: '',
            },
            register: {
                name: '',
                email: '',
                password: '',
                confirm_password: '',
                status: true,
                newsletter: false,
                role: 'caregiver',
                terms: false,
                user_type: 'caregiver',
                user_profession: '',
            },
            reset: {
                email: '',
            },
            recover: {
                email: '',
                password: '',
                confirm_password: '',
                reset_token: ''
            },
            registerStep: 1,
            userProfessionData: {
                'caregiver': [
                    'I am a Family Member',
                    'I am a Friend',
                    'Other'
                ],
                'professional': [
                    'I am an Educator',
                    'Other'
                ]
            }
        }
    },
    validations: {
        login: {
            email: {required: required},
            password: {required: required},
        },
        register: {
            name: {required: required, minLength: minLength(2)},
            email: {required: required, email},
            password: passwordValidators,
            confirm_password: {required, sameAs: sameAs('password')},
            terms: {required: required, minValue: minValue(true)},
        },
        reset: {
            email: {required, email}
        },
        recover: {
            password: {required, minLength: minLength(6)},
            confirm_password: {required, sameAs: sameAs('password')},
        },
    },
    watch: {
        $route(to) {
            if (to.name === 'register') {
                this.form = 'register';
            } else if (to.name === 'login') {
                this.form = 'login';
            } else {
                this.form = to.name;
            }
        }
    },
    computed: {
        ...mapState({
            user: state => state.user,
        })
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from;
        });
    },
    created: function () {
        // $('body').removeClass('2-columns');
        // $('body').addClass('bg-full-screen-image blank-page 1-column');
        // $('body').attr('data-col', '1-column');
    },
    mounted: function () {
        if (this.$auth.getToken()) {
            this.$router.push({name: 'home'});
        } else {
            // $('#preloader').fadeOut('slow');
        }
        if (this.$route.name === 'register') {
            this.form = 'register';
        }
        if (this.$route.query.resetToken) {
            this.form = 'recover';
            this.recover.email = this.$route.query.email;
            this.recover.reset_token = this.$route.query.resetToken;
        }
        // if (this.$route.query.confirmToken) {
        //     this.confirmAccount();
        // }
        const el = document.getElementById('app-div');
        if (el) {
          el.classList.add('h-100');
        }
    },
    methods: {
        signIn: function () {
            this.$v.login.$touch();
            if (this.$v.login.$invalid == true) {
                return false;
            }
            this.loading.login = true;
            this.$http.post("/auth/login", this.login)
                .then((res) => {
                    this.loading.login = false;
                    if (res.body.data.token) {
                        this.$store.commit('setUser', res.body.data.user);
                        this.$auth.setToken(res.body.data.token);
                        this.$auth.setImpersonation(false);
                        this.$auth.setRole('caregiver');
                        this.$acl.change('caregiver');
                        this.$gtag.event('login_attempted', {
                            method: 'email',
                            success: true
                        });
                        this.$gtag.event('login_successful', {
                            method: 'email',
                            user_id: res.body.data.user.id
                        });
                        // this.$role.setPermissions(res.body.user.role, res.body.data.user.permission_codes);
                        setTimeout(() => {
                            if (sessionStorage.getItem("caregiver:redirectLoginPathName")) {
                                this.$router.push({
                                    name: sessionStorage.getItem("caregiver:redirectLoginPathName"),
                                    params: JSON.parse(sessionStorage.getItem("caregiver:redirectLoginParams")),
                                    query: JSON.parse(sessionStorage.getItem("caregiver:redirectLoginQuery"))
                                });
                            } else {
                                this.$router.push({name: 'home'});
                            }
                        }, 200);
                    }
                })
                .catch((error) => {
                    this.loading.login = false;
                    this.$gtag.event('login_attempted', {
                        method: 'email',
                        success: false
                    });
                    if (error.body.status_code === 403) {
                        this.$modal.show('wrongAccountTypeModal')
                    }
                    console.log('error', error.body.status_code)
                });
        },
        registerNextStep: function () {
          this.$v.register.$touch();
          if (this.$v.register.$invalid == true) {
            return false;
          }
          this.registerStep++;
        },
        registerPreviousStep: function () {
            this.registerStep--;
        },
        selectUserTypeDetail: function (type) {
            this.other_selected = type === 'Other';
            this.register.user_profession = this.other_selected ? '' : type;
        },
        signUp: function () {
            this.$v.register.$touch();
            if (this.$v.register.$invalid == true) {
                this.registerPreviousStep();
                return false;
            }
            this.error = '';
            this.message = '';
            this.loading.register = true;
            this.$http.post("/auth/signup", this.register)
                .then((res) => {
                    this.loading.register = false;
                    if (res.body.data.token) {
                        this.$store.commit('setUser', res.body.data.user);
                        this.$auth.setToken(res.body.data.token);
                        this.$auth.setImpersonation(false);
                        this.$auth.setRole('caregiver');
                        this.$acl.change('caregiver');
                        this.$gtag.event('sign_up_completed', {
                            method: 'email',
                            user_id: res.body.data.user.id
                        });
                        // this.$role.setPermissions(res.body.data.users.role, res.body.data.users.user.permission_codes);
                        this.$router.push({name: 'home'});
                    } else {
                        this.message = res.body.message;
                        this.register = {
                            name: '',
                            email: '',
                            password: '',
                            confirm_password: '',
                            terms: false,
                        }
                        this.$v.register.$reset();
                        this.form = 'login'
                    }
                })
                .catch(function (error) {
                    this.registerStep = 1;
                    this.loading.register = false;
                });
        },
        AuthProvider(provider) {
            this.$gtag.event('sign_up_started', {
                method: provider,
                user_id: null
            });
            var self = this
            this.$socialAuth.authenticate(provider).then(response => {
                self.SocialLogin(provider,response)
            }).catch(err => {
                console.log({err:err})
            })
        },

        SocialLogin(provider,response) {
            this.$http.post(`/auth/login/${provider}/callback`, response)
                .then(res => {
                    if (res.body.token) {
                        this.$store.commit('setUser', res.body.user);
                        this.$auth.setToken(res.body.token);
                        this.$auth.setImpersonation(false);
                        this.$auth.setRole('caregiver');
                        this.$acl.change('caregiver');
                        this.$gtag.event('login_attempted', {
                            method: provider,
                            success: true
                        });
                        this.$gtag.event('login_successful', {
                            method: provider,
                            user_id: res.body.data.user.id
                        });
                        this.$router.push({name: 'home'});
                    } else {
                        this.message = res.body.message;
                        this.register = {
                            name: '',
                            email: '',
                            password: '',
                            confirm_password: '',
                            terms: false,
                        }
                        this.$v.register.$reset();
                        this.form = 'login'
                    }
                }).catch(err => {
                this.$gtag.event('login_attempted', {
                    method: provider,
                    success: false
                });
                console.log({err:err})
            })
        },

        resetPasswordEmail: function () {
            this.$v.reset.$touch();
            if (this.$v.reset.$invalid == true) {
                return false;
            }
            this.loading.reset = true;
            this.$http.post("/auth/forgot/password", this.reset)
                .then(function (res) {
                    this.loading.reset = false;
                    this.$gtag.event('password_reset_requested', {
                        email_entered: this.reset.email
                    });
                    this.form = 'email_sent'
                })
                .catch(function (res) {
                    this.loading.reset = false;
                })
        },
        recoverPassword: function () {
            this.$v.recover.$touch();
            if (this.$v.recover.$invalid == true) {
                return false;
            }
            this.loading.recover = true;
            this.$http.post("/auth/reset", this.recover)
                .then(function (res) {
                    this.loading.recover = false;
                    this.form = "login";
                    this.$router.replace(this.$router.currentRoute.path);
                })
                .catch(function (res) {
                    this.loading.recover = false;
                })
        },
        switchToLogin() {
            if (this.$router.name === 'login') {
                return;
            }
            this.$router.push({name: 'login'});
            this.form = 'login';
        },
        switchToRegister() {
            this.$modal.hide('wrongAccountTypeModal');
            this.$router.push({name: 'register'});
            this.form = 'register';
            this.$gtag.event('sign_up_started', {
                method: 'email',
                user_id: null
            });
        },
        confirmAccount() {
            this.loading.login = true;
            this.$http.post("/auth/confirm-account", {
                confirmation_token: this.$route.query['confirmToken']
            })
                .then(function (res) {
                    this.loading.login = false;
                    this.$router.replace(this.$router.currentRoute.path);
                })
                .catch(function (res) {
                    this.loading.login = false;
                })
        },
    },
}
</script>

